if (!customElements.get('rss-mobile-search')) {
  customElements.define('rss-mobile-search', class extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('button');
      this.header = this.closest('header');
      this.panel = this.header?.querySelector('#rss-header-search');
      this.input = this.panel?.querySelector('input[type="search"]');
      if (!this.button || !this.panel || !this.input) return;
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.header.classList.add('rss-compact-search-ready');
      this.button.addEventListener('click', () => {
        const open = this.button.getAttribute('aria-expanded') !== 'true';
        const menu = this.header.querySelector('.head-slot-nav-mobile-link');
        if (open && menu?.getAttribute('aria-expanded') === 'true') menu.click();
        this.setOpen(open);
        if (open) this.input.focus({ preventScroll: true });
      }, options);
      this.header.addEventListener('keydown', event => {
        if (event.key === 'Escape' && this.button.getAttribute('aria-expanded') === 'true') {
          this.setOpen(false);
          this.button.focus({ preventScroll: true });
        }
      }, options);
      this.header.querySelector('.head-slot-nav-mobile-link')?.addEventListener('click', () => this.setOpen(false), options);
    }

    setOpen(open) {
      this.button.setAttribute('aria-expanded', String(open));
      this.header.classList.toggle('rss-search-open', open);
    }

    disconnectedCallback() {
      this.controller?.abort();
    }
  });
}

if (!customElements.get('rss-mobile-buy-bar')) {
  customElements.define('rss-mobile-buy-bar', class extends HTMLElement {
    connectedCallback() {
      this.info = document.getElementById(`Product-${this.dataset.section}`);
      this.form = document.getElementById(this.dataset.form);
      this.sourceButton = this.form?.querySelector('.button-add-to-cart');
      this.button = this.querySelector('.rss-mobile-buy-button');
      this.price = this.querySelector('.rss-mobile-buy-price');
      if (!this.info || !this.sourceButton || !this.button) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.media = matchMedia('(max-width: 989px)');
      this.schedule = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = 0; this.update(); });
      };
      this.button.addEventListener('click', () => {
        if (this.sourceButton.disabled || this.sourceButton.getAttribute('aria-disabled') === 'true') return;
        if (this.form.querySelector('.recipient-form, [name="selling_plan"]')) {
          this.sourceButton.scrollIntoView({ block: 'center', behavior: 'auto' });
          this.sourceButton.focus({ preventScroll: true });
          return;
        }
        this.sourceButton.click();
      }, options);
      this.querySelector('.rss-mobile-buy-options')?.addEventListener('click', event => {
        event.preventDefault();
        const target = this.info.querySelector('variant-selects select, variant-radios input:not([disabled])') || this.sourceButton;
        target.scrollIntoView({ block: 'center', behavior: 'auto' });
        target.focus({ preventScroll: true });
      }, options);
      window.addEventListener('scroll', this.schedule, { ...options, passive: true });
      window.addEventListener('resize', this.schedule, options);
      window.visualViewport?.addEventListener('resize', this.schedule, options);
      this.media.addEventListener('change', this.schedule, options);
      this.info.addEventListener('change', this.schedule, options);
      this.observer = new MutationObserver(this.schedule);
      this.observer.observe(this.info, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'class'] });
      this.bodyObserver = new MutationObserver(this.schedule);
      this.bodyObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
      this.resizeObserver = new ResizeObserver(this.schedule);
      this.resizeObserver.observe(this);
      this.schedule();
    }

    update() {
      const source = document.getElementById(`price-${this.dataset.section}`)?.querySelector('.price');
      const html = source?.outerHTML || '';
      if (html !== this.lastPrice) {
        this.lastPrice = html;
        this.price.replaceChildren();
        if (source) {
          const copy = source.cloneNode(true);
          copy.removeAttribute('id');
          copy.querySelectorAll('[id]').forEach(node => node.removeAttribute('id'));
          this.price.append(copy);
        }
      }
      const text = this.sourceButton.querySelector('span')?.textContent.trim() || this.sourceButton.textContent.trim();
      if (this.button.textContent !== text) this.button.textContent = text;
      this.button.disabled = this.sourceButton.disabled || this.sourceButton.getAttribute('aria-disabled') === 'true';
      const preview = document.getElementById('PBarNextFrame');
      const previewRect = preview?.getBoundingClientRect();
      const previewHeight = previewRect && previewRect.top < innerHeight && previewRect.bottom > 0 ? Math.min(previewRect.height, 100) : 0;
      this.style.setProperty('--rss-preview-offset', `${previewHeight}px`);
      const keyboard = window.visualViewport && window.visualViewport.height < innerHeight * .75;
      const overlay = document.body.matches('.header-mini-cart-open,.mobile-menu-open') || document.querySelector('.product-media-modal[open],#header.rss-search-open');
      const visible = this.media.matches && this.sourceButton.getBoundingClientRect().bottom < 0 && !keyboard && !overlay;
      this.hidden = !visible;
      document.body.classList.toggle('rss-buy-visible', visible);
      const space = visible ? this.getBoundingClientRect().height : 0;
      document.body.style.setProperty('--rss-buy-space', `${space}px`);
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.bodyObserver?.disconnect();
      this.resizeObserver?.disconnect();
      cancelAnimationFrame(this.frame);
      document.body.classList.remove('rss-buy-visible');
      document.body.style.removeProperty('--rss-buy-space');
    }
  });
}
